import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../../api";
import { useUserAuth } from "../../../User/UserAuthContext/UserAuthContext";
import "./PlayersList.css";
import { ROUTES, routeWithId } from "../../../config/routes";
import Loader from "../../common/Loader";

function StudentList() {
  const { user } = useUserAuth();
  const [students, setStudents] = useState([]);
  const [isLoading, setLoading] = useState(true); // state for loader

  const fetchStudentList = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token not found");
      }

      const response = await fetch(`${BASE_URL}students/list/`, {
        method: "GET",
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setStudents(data.data);
      setLoading(false);
      // console.log(data.data); // log the fetched data
      // Check is_paid and update transaction status if needed
      data.data.forEach(async (student) => {
        if (!student.is_paid) {
          try {
            const paymentResponse = await fetch(
              `${BASE_URL}payments/v1/transaction_payment_update/`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Token ${token}`,
                },
                body: JSON.stringify({ student_id: student.id }),
              }
            );

            if (!paymentResponse.ok) {
              throw new Error("Failed to update payment status");
            }
          } catch (error) {
            console.error("Error updating payment status:", error);
          }
        }
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchStudentList();
    } else {
      setLoading(false);
    }
  }, [user]);

  return (
    <>
      {isLoading ? (
        <Loader text="Loading registered players..." />
      ) : (
        <>
          <div className="Register-players-list">
            <center>
              <h1>Players you have enrolled</h1>
            </center>
            {students.length > 0 ? (
              <div className="main">
                {students.map((student) => (
                  <div className="mainCard-list" key={student.id}>
                    <Link to={routeWithId.student(student.id)} className="card">
                      {!student.is_paid ? (
                        <div className="Payment-pending">
                          <div className="pen">
                            <h3>Payment pending</h3>
                          </div>
                        </div>
                      ) : (
                        <div className="Payment-pending">
                          <div className="pen-2">
                            <h3>Paid</h3>
                          </div>
                        </div>
                      )}

                      <div className="PlayerCard-list">
                        <div className="img">
                          <img src={student.photo} alt=""></img>
                        </div>
                        <div className="text">
                          <h2 className="head"> {student.full_name}</h2>
                          <h3>
                            <i className="fa-solid fa-phone"></i>
                            {student.mobile}
                          </h3>
                          <h3>
                            {" "}
                            <i className="fa-solid fa-envelope"></i>
                            {student.email}
                          </h3>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            ) : (
              <center>
                <div className="PlayerList_no-players">
                  <p>No student data to display</p>
                  <Link to={ROUTES.registerForm}>Add New Player</Link>
                </div>
              </center>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default StudentList;
